import gql from 'graphql-tag';

export default gql`
  query getRecommendSkuForSigninUser {
    getRecommendSkuForSigninUser {
      data {
        id
        imageUrl
        supplierInternalCode
        name
        tagImageVn
        tagImageEn
      }
    }
  }
`;
